import { render, staticRenderFns } from "./WorkSubject.vue?vue&type=template&id=30e66670"
import script from "./WorkSubject.vue?vue&type=script&lang=js"
export * from "./WorkSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports